module.exports = __webpack_public_path__ + "img/PL00132.c9cdff19.png";